(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeyjarreviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hj-reviews')) {
    customElements.define('hj-reviews', class extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector('[data-lightbox-text]')) {
          this.readyObserver?.disconnect();
          this.readyObserver = new MutationObserver(() => {
            if (this.querySelector('[data-lightbox-text]')) this.connectedCallback();
          });
          this.readyObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        this.readyObserver?.disconnect();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.grid = this.querySelector('[data-review-grid]');
        if (!this.grid) return;
        this.cards = Array.from(this.querySelectorAll('[data-review-card]:not([data-placeholder])'));
        this.pageSize = Number(this.dataset.pageSize) || 12;
        this.visibleCount = this.pageSize;
        this.loadMore = this.querySelector('[data-load-more]');
        this.dialog = this.querySelector('[data-lightbox]');
        this.submitDialog = this.querySelector('[data-submit-dialog]');
        this.reviewForm = this.querySelector('[data-submit-form]');
        this.uploads = [];
        this.classList.add('hj-reviews--enhanced');
        this.querySelector('[data-write-review]').hidden = typeof this.submitDialog.showModal !== 'function';
        this.querySelector('[data-footer]').hidden = this.cards.length === 0;
        this.reviewForm.addEventListener('change', (event) => {
          if (event.target.name === 'rating') this.updateRating();
        }, options);
        this.querySelector('[data-review-files]').addEventListener('change', (event) => this.addUploads(event.target), options);
        this.reviewForm.addEventListener('submit', (event) => {
          event.preventDefault();
          ['name', 'review'].forEach(name => {
            const field = this.reviewForm.elements.namedItem(name);
            field.value = field.value.trim();
          });
          if (!this.reviewForm.reportValidity()) return;
          this.querySelector('[data-review-form-panel]').hidden = true;
          const confirmation = this.querySelector('[data-review-confirmation]');
          confirmation.hidden = false;
          this.submitDialog.setAttribute('aria-labelledby', this.querySelector('[data-confirmation-title]').id);
          this.reviewForm.reset();
          this.clearUploads();
          confirmation.focus();
        }, options);
        this.submitDialog.addEventListener('click', (event) => {
          if (event.target === this.submitDialog) this.submitDialog.close();
        }, options);
        this.submitDialog.addEventListener('close', () => {
          this.reviewForm.reset();
          this.clearUploads();
          if (this.lastWriteTrigger?.isConnected) this.lastWriteTrigger.focus({ preventScroll: true });
        }, options);
        this.updateRating();
        this.loadMore.addEventListener('click', () => {
          const firstNewCard = this.filteredCards[this.visibleCount];
          this.visibleCount += this.pageSize;
          this.renderCards();
          if (firstNewCard) {
            firstNewCard.tabIndex = -1;
            firstNewCard.focus({ preventScroll: true });
          }
        }, options);
        this.addEventListener('click', (event) => {
          const writeButton = event.target.closest('[data-write-review]');
          if (writeButton && this.contains(writeButton)) {
            this.lastWriteTrigger = writeButton;
            this.querySelector('[data-review-form-panel]').hidden = false;
            this.querySelector('[data-review-confirmation]').hidden = true;
            this.querySelector('[data-submit-error-message]').hidden = true;
            this.submitDialog.setAttribute('aria-labelledby', this.querySelector('.hj-reviews__submit-title').id);
            this.updateRating();
            this.submitDialog.showModal();
          }
          const closeButton = event.target.closest('[data-close-review]');
          if (closeButton && this.contains(closeButton)) this.submitDialog.close();
          const removeButton = event.target.closest('[data-remove-upload]');
          if (removeButton && this.contains(removeButton)) {
            const index = Number(removeButton.dataset.removeUpload);
            URL.revokeObjectURL(this.uploads[index].url);
            this.uploads.splice(index, 1);
            this.renderUploads();
            this.querySelector('[data-review-files]').focus();
          }
          const readButton = event.target.closest('[data-read-more-button]');
          if (readButton && this.contains(readButton)) {
            const text = readButton.closest('[data-review-card]').querySelector('[data-review-text]');
            const expanded = text.classList.toggle('is-expanded');
            readButton.setAttribute('aria-expanded', String(expanded));
            readButton.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
          }
          const photo = event.target.closest('[data-review-photo]');
          if (photo && this.contains(photo) && typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            this.openGallery(photo);
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.lastTrigger?.isConnected) this.lastTrigger.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.selectPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.querySelector('[data-previous-photo]').addEventListener('click', () => this.selectPhoto(this.photoIndex - 1), options);
        this.querySelector('[data-next-photo]').addEventListener('click', () => this.selectPhoto(this.photoIndex + 1), options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.cards.find(card => card.dataset.blockId === event.detail?.blockId);
          if (!selected) return;
          this.visibleCount = this.cards.length;
          this.renderCards();
          selected.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver((entries) => {
          const width = entries[0]?.contentRect.width;
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          this.measureText();
        });
        this.resizeObserver.observe(this.grid);
        this.renderCards();
        document.fonts?.ready.then(() => { if (this.isConnected) this.measureText(); });
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        if (this.submitDialog?.open) this.submitDialog.close();
        this.clearUploads();
        cancelAnimationFrame(this.measureFrame);
      }

      renderCards() {
        const ordered = this.cards;
        this.filteredCards = ordered;
        const visible = new Set(this.filteredCards.slice(0, this.visibleCount));
        ordered.forEach(card => {
          card.hidden = !visible.has(card);
          this.grid.appendChild(card);
        });
        const shown = visible.size;
        const total = this.filteredCards.length;
        this.loadMore.hidden = shown >= total;
        this.querySelector('[data-footer]').hidden = shown >= total;
        this.measureText();
      }

      updateRating() {
        const rating = Number(this.reviewForm.elements.namedItem('rating').value);
        this.querySelectorAll('.hj-reviews__rating-choice').forEach(choice => {
          choice.classList.toggle('is-selected', Number(choice.querySelector('input').value) <= rating);
        });
      }

      addUploads(input) {
        const allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        const files = Array.from(input.files || []).filter(file => !this.uploads.some(upload => upload.file.name === file.name && upload.file.size === file.size && upload.file.lastModified === file.lastModified));
        const error = this.querySelector('[data-submit-error-message]');
        if (files.length + this.uploads.length > 3 || files.some(file => !allowed.includes(file.type) || !file.size || file.size > 10 * 1024 * 1024)) {
          error.textContent = this.dataset.fileError;
          error.hidden = false;
        } else {
          error.hidden = true;
          files.forEach(file => this.uploads.push({ file, url: URL.createObjectURL(file) }));
          this.renderUploads();
        }
        input.value = '';
      }

      renderUploads() {
        const previews = this.querySelector('[data-upload-previews]');
        previews.replaceChildren();
        this.uploads.forEach((upload, index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'hj-reviews__upload-preview';
          const image = document.createElement('img');
          image.src = upload.url;
          image.alt = upload.file.name;
          image.width = 80;
          image.height = 80;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hj-reviews__remove-upload';
          button.dataset.removeUpload = String(index);
          button.setAttribute('aria-label', this.dataset.removePhoto + ' ' + (index + 1));
          button.textContent = '×';
          wrapper.append(image, button);
          previews.appendChild(wrapper);
        });
      }

      clearUploads() {
        (this.uploads || []).forEach(upload => URL.revokeObjectURL(upload.url));
        this.uploads = [];
        this.querySelector('[data-upload-previews]')?.replaceChildren();
      }

      measureText() {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => {
          this.cards.filter(card => !card.hidden).forEach(card => {
            const text = card.querySelector('[data-review-text]');
            const button = card.querySelector('[data-read-more-button]');
            if (!text || !button) return;
            button.hidden = !text.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 1;
          });
        });
      }

      openGallery(trigger) {
        const card = trigger.closest('[data-review-card]');
        this.photos = Array.from(card.querySelectorAll('[data-review-photo]'));
        this.lastTrigger = trigger;
        this.querySelector('[data-lightbox-title]').textContent = card.querySelector('[data-review-author]').textContent;
        this.querySelector('[data-lightbox-text]').textContent = card.querySelector('[data-review-text]')?.innerText || '';
        const thumbnails = this.querySelector('[data-thumbnails]');
        thumbnails.replaceChildren();
        this.photos.forEach((photo, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hj-reviews__thumbnail';
          button.setAttribute('aria-label', this.dataset.photoLabel + ' ' + (index + 1));
          const image = document.createElement('img');
          image.src = photo.querySelector('img').getAttribute('src');
          image.alt = '';
          image.width = 56;
          image.height = 56;
          button.appendChild(image);
          button.addEventListener('click', () => this.selectPhoto(index));
          thumbnails.appendChild(button);
        });
        thumbnails.hidden = this.photos.length < 2;
        this.querySelector('[data-previous-photo]').hidden = this.photos.length < 2;
        this.querySelector('[data-next-photo]').hidden = this.photos.length < 2;
        this.selectPhoto(this.photos.indexOf(trigger));
        this.dialog.showModal();
      }

      selectPhoto(index) {
        if (!this.photos?.length) return;
        this.photoIndex = (index + this.photos.length) % this.photos.length;
        const source = this.photos[this.photoIndex];
        const image = this.querySelector('[data-lightbox-image]');
        image.src = source.href;
        image.alt = source.querySelector('img').alt;
        this.querySelector('[data-photo-position]').textContent = (this.photoIndex + 1) + ' / ' + this.photos.length;
        this.querySelectorAll('.hj-reviews__thumbnail').forEach((button, thumbnailIndex) => {
          button.setAttribute('aria-pressed', String(thumbnailIndex === this.photoIndex));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
